<template>
  <el-dialog
    title="选择企业"
    :visible.sync="visible"
    width="720px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.vendorName"
        placeholder="请输入企业名称"
        style="width: 200px"
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      border
      highlight-current-row
      :data="list"
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        width="50">
        <template slot-scope="{row}">
          <el-radio
            v-model="current.vendorId"
            :label="row.vendorId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="企业名称"
        prop="vendorName">
      </el-table-column>
      <el-table-column
        label="联系人"
        prop="vendorPerson"
        width="120"
      ></el-table-column>
    </el-table>
    <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange">
    </el-pagination>
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'VendorSelectModal',
  components: {},
  props: {
    callback: Function,
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        vendorName: ''
      },
      totalNum: 0,
      current: {}
    }
  },
  watch: {
    current: {
      handler(val) {
        console.log(val)
      },
      deep: true
    }
  },
  created() { },
  mounted() { },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.current = {}
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    add() {
      if (!this.current.vendorId) {
        this.$message.error('请选择一家企业')
        return
      }
      this.callback && this.callback(this.current)
      if (this.autoClose) {
        this.toggleModal(false)
      }
    },
    handleCurrentRowChange(row) {
      this.current = row || {}
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('account/getvendors', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch() {
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
